import { marketUnits, type MarketOverview, type MarketFundingSource } from "../domain/market";
import type { Locale } from "../domain/types";

export function availableLpSources(overview: MarketOverview | null, now: number): MarketFundingSource[] {
  if (!overview) return [];
  const sources: MarketFundingSource[] = [];
  if (BigInt(overview.rewardAvailableMicros) > 0n) sources.push("reward");
  if (overview.caratFunding && Date.parse(overview.caratFunding.endsAt) > now && BigInt(overview.caratFunding.availableCarats) > 0n) sources.push("carats");
  return sources;
}
export function lpSourceSpendable(overview: MarketOverview | null, source: MarketFundingSource | null, now: number): string {
  if (!overview || !source || !availableLpSources(overview, now).includes(source)) return "0";
  return source === "carats" ? overview.caratFunding?.spendableMicros ?? "0" : overview.rewardSpendableMicros ?? overview.rewardAvailableMicros;
}
export const marketFundingCopy = (locale: Locale) => locale === "ru" ? {
  title: "Оплата вклада платформы", reward: "Награды", carats: "Караты", amount: "Вклад платформы",
  debit: "Спишется карат", units: "карат", noSource: "Пока нет средств для вклада. Можно добыть караты или получить сезонную награду.",
  surcharge: "Каратов понадобится на {percent}% больше по текущей оценке. Надбавка не увеличивает позицию и не расходует лимит.",
  estimate: "Караты рассчитываются по текущей доле в фонде сезона. Потраченные караты больше не участвуют в распределении наград.",
  until: "Оплата каратами доступна до", available: "На выбранном счёте", caratBudget: "Вклад после надбавки",
  reserved: "Караты в резерве до создания позиции. При отмене они вернутся на тот же счёт.",
  released: "Караты возвращены", consumed: "Оплачено каратами", pending: "Зарезервировано карат",
} : {
  title: "Pay for the platform contribution", reward: "Rewards", carats: "Carats", amount: "Platform contribution",
  debit: "Carats to spend", units: "carats", noSource: "No funds available yet. Earn carats or claim a season reward to contribute.",
  surcharge: "Paying with carats costs {percent}% more at their current valuation. The surcharge does not increase the contribution or use extra allowance.",
  estimate: "Carats are valued at their current share of the season fund. Spent carats no longer count toward season rewards.",
  until: "Carat payments available until", available: "Selected account balance", caratBudget: "Contribution after surcharge",
  reserved: "Carats are held until your position is created. Cancelling returns them to the same account.",
  released: "Carats returned", consumed: "Paid with carats", pending: "Carats reserved",
};
export function caratSurchargeLabel(bps: number, locale: Locale): string {
  return marketUnits(String(bps), 2, locale, bps % 100 === 0 ? 0 : 2);
}
